import { Environment, Environments } from '@telstra-connect/config/environments'
import { Config, getCurrentEnvironment } from '@telstra-connect/config/config'
import { ApplicationsFlags } from '@telstra-connect/subscriptions/state'

type Flag = {
  [key in Environments]: boolean | string
}

interface IFlag extends Flag { }

type FlagData<TFlagProps> = {
  [flagProp in keyof TFlagProps]: IFlag
}

const flagIsSet = (flag: IFlag, environment: Environment) => {
  return flag[environment]
}

type GetStateReturn = Partial<
  {
    [appName in keyof ApplicationsFlags]?: Partial<ApplicationsFlags[appName]>
  }
>

export class FeatureFlagsHelper<TAppName extends keyof ApplicationsFlags> {
  public getFlags: () => ApplicationsFlags[TAppName]

  private staticFlags: ApplicationsFlags[TAppName]

  constructor(
    private applicationName: TAppName,
    private getFlagsConfigFromState?: () => GetStateReturn,
    private flagData?: FlagData<GetStateReturn[TAppName]>,
  ) {
    if (this.flagData) {
      this.setFromStaticValues()
    }
    if (Config.loadFlagsFromSubscriptions && this.getFlagsConfigFromState) {
      this.setFromSubscriptions()
    }
  }

  private setFromStaticValues = () => {
    const environment = getCurrentEnvironment()
    this.staticFlags = Object.keys(this.flagData).reduce(
      (otherFlags, flagName) => ({
        ...otherFlags,
        [flagName]: flagIsSet(this.flagData[flagName], environment),
      }),
      {},
    ) as ApplicationsFlags[TAppName]

    this.getFlags = () => this.staticFlags
  }

  private setFromSubscriptions = () => {
    this.getFlags = () => {
      const dynamicFlagsConfig = this.getFlagsConfigFromState()
      const dynamicFlags = dynamicFlagsConfig && dynamicFlagsConfig[this.applicationName]
      return {
        ...(this.staticFlags as {}),
        ...(dynamicFlags as {}),
      } as ApplicationsFlags[TAppName]
    }
  }
}
